
import { prop, Vue } from "vue-class-component";
import { PropType } from "vue";

class Props {
  title = prop<string>({
    default: "",
    type: String
  });
  onClose = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
}

export default class Geolocation extends Vue.with(Props) {}
